
$(document).ready(function(){

  $(document).on('change', '.option-ops-1',function(){
    var value = $(this).val();
    $(document).find('.button-show-opt,.option-desc,.items-var').hide()
    if( $(document).find('[data-opt1="'+value+'"]').length > 0 ){
      $(document).find('.option-desc').show();
      $(document).find('.items-var').removeClass('active');
      $(document).find('[data-opt1="'+value+'"]').addClass('active').show();
    }
  });
  
  setTimeout(function(){
    $( "#datepicker" ).datepicker({ minDate: 0});
  },4000)
    
  $(document).on('click','.tabs li a',function(e){
    e.preventDefault();
    var pare = $(this).closest('.product__description-container');
    $(pare).find('.tabs li a').removeClass('active');
    $(pare).find('.tabs-content li').removeClass('active');
    $(this).addClass('active');
    var nextTab = $(this).attr('href');
     $(pare).find('.tabs-content '+nextTab+'').addClass('active');
  })

  $(document).on('change','.select-opt-2',function(){
    if( $(this).val() == 'NO Tint' ){
      $('.tint-option-select').addClass('hidden');
      $('#tint_preference_hidden,.tint-option-select input').val("")
    }else{
      $('.tint-option-select').removeClass('hidden');
    }
  })
  $(document).keyup('.tint-option-select input',function(){
    var value = $('#main_tint').val();
    $('#tint_preference_hidden').val(value);
    console.log(value)
  })
  
})




// $(document).ready(function() {
//     // Listen for the "Add to Cart" button click event
//     $('#addToCart').on('click', function() {
//         var productTitle = $(this).data('product-title'); // Get the product title
//         var variant = $(this).data('variant'); // Get the selected variant
        
//         // Check if the added product matches the criteria
//         if (productTitle === "REGAL® Select Interior Paint" && variant === "Quart") {
//             // Use Shopify AJAX Cart API to add the "Variant Fee" product with the same variant
//             $.ajax({
//                 type: 'POST',
//                 url: '/cart/add.js', // Use the appropriate URL for your Shopify store
//                 data: {
//                     quantity: 1, // Adjust quantity as needed
//                     id: YOUR_VARIANT_FEE_PRODUCT_ID // Specify the variant fee product ID
//                 },
//                 dataType: 'json',
//                 success: function() {
//                     // Both products have been added to the cart
//                     alert('Products added to cart');
                    
//                     // You can optionally redirect to the cart page or perform other actions
//                     // window.location.href = '/cart'; // Redirect to the cart page
//                 },
//                 error: function() {
//                     // Handle errors if any
//                     alert('Error adding products to cart');
//                 }
//             });
//         }
//     });
// })




var Shopify = Shopify || {};

Shopify.optionsMap = {};

Shopify.uniq = function(array) {
  return array.filter(function(el, index, self) {
    return index === self.indexOf(el);
  });
};

Shopify.updateOptionsInSelector = function(selectorIndex) {
  var singleOptionSelectors = jQuery('select.js-variant-selector');


  switch (selectorIndex) {
    case 0:
      var key = 'root';
      var selector = singleOptionSelectors.eq(0);
      break;
    case 1:
      var key = singleOptionSelectors.eq(0).val();
      var selector = singleOptionSelectors.eq(1);
      break;
    case 2:
      var key = singleOptionSelectors.eq(0).val();  
      key += ' / ' + singleOptionSelectors.eq(1).val();
      var selector = singleOptionSelectors.eq(2);
  }
  
  var initialValue = selector.val();
  selector.empty();    
  var availableOptions = Shopify.optionsMap[key];
  for (var i=0; i<availableOptions.length; i++) {
    var option = availableOptions[i];
    var newOption = $('<option />').val(option).html(option);
    selector.append(newOption);
  }
  jQuery('.swatch[data-option-index="' + selectorIndex + '"] .swatch-element').each(function() {
    var t = $(this);
    if (jQuery.inArray(t.attr('data-value'), availableOptions) !== -1) {
      t.removeClass('soldout').show().find('[type="radio"]').removeAttr('disabled checked');
    }
    else {
      t.addClass('soldout').hide().find('[type="radio"]').removeAttr('checked').attr('disabled','disabled');
    }
  });
  if (jQuery.inArray(initialValue, availableOptions) !== -1) {
    selector.val(initialValue);
  }
  console.log('here-custom')
  selector.trigger('change');

};

Shopify.linkOptionSelectors = function(product) {
  // Building our mapping object.
  for (var i=0; i<product.variants.length; i++) {
    var variant = product.variants[i];
    if (variant.available) {
      // Gathering values for the 1st drop-down.
      Shopify.optionsMap['root'] = Shopify.optionsMap['root'] || [];
      Shopify.optionsMap['root'].push(variant.option1);
      Shopify.optionsMap['root'] = Shopify.uniq(Shopify.optionsMap['root']);
      // Gathering values for the 2nd drop-down.
      if (product.options.length > 1) {
        var key = variant.option1;
        Shopify.optionsMap[key] = Shopify.optionsMap[key] || [];
        Shopify.optionsMap[key].push(variant.option2);
        Shopify.optionsMap[key] = Shopify.uniq(Shopify.optionsMap[key]);
      }
      // Gathering values for the 3rd drop-down.
      if (product.options.length === 3) {
        var key = variant.option1 + ' / ' + variant.option2;
        Shopify.optionsMap[key] = Shopify.optionsMap[key] || [];
        Shopify.optionsMap[key].push(variant.option3);
        Shopify.optionsMap[key] = Shopify.uniq(Shopify.optionsMap[key]);
      }
    }
  }

  var singleOptionSelectors = jQuery('select.js-variant-selector');

  // Update options right away.
  Shopify.updateOptionsInSelector(0);

  if (product.options.length > 1) Shopify.updateOptionsInSelector(1);
  if (product.options.length === 3) Shopify.updateOptionsInSelector(2);
  // When there is an update in the first dropdown.
  singleOptionSelectors.eq(0).change(function() {
    Shopify.updateOptionsInSelector(1);
    if (product.options.length === 3) Shopify.updateOptionsInSelector(2);
    return true;
  });
  // When there is an update in the second dropdown.
  singleOptionSelectors.eq(1).change(function() {
    if (product.options.length === 3) Shopify.updateOptionsInSelector(2);
    return true;
  });
  
};
jQuery(function() {
  var product = JSON.parse(
    document.querySelector('.product-json').textContent
  );

  Shopify.linkOptionSelectors(product);
});